import type { ConfirmationResponse } from "@/features/register/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AddressCreate, AddressFullType } from "../../types";
import { AddressApiClient } from "../api-client/api-client";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { QueryOptionsFactory } from "@/features/company/utils";

export const useAddress = () => {
  const queryClient = useQueryClient();
  const { leUuid } = useCompanyContext();
  const editAddressMutation = () =>
    useMutation<ConfirmationResponse, Error, { leUuid: string | null; address: AddressFullType }>({
      mutationFn: async ({ leUuid, address }) => AddressApiClient.edit(address, leUuid),
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: leUuid
            ? QueryOptionsFactory.legalEntity(leUuid ?? "").queryKey
            : ["user", "profile"]
        })
    });
  const createUserAddressMutation = () =>
    useMutation<ConfirmationResponse, Error, { userUUID: string; address: AddressCreate }>({
      mutationFn: async ({ userUUID, address }) =>
        AddressApiClient.create(userUUID, address, leUuid ?? null),
      onSuccess: () =>
        leUuid
          ? queryClient.invalidateQueries({
              queryKey: QueryOptionsFactory.legalEntity(leUuid ?? "").queryKey
            })
          : queryClient.invalidateQueries({ queryKey: ["user", "profile"] })
    });

  return { createAddressMutation: createUserAddressMutation, editAddressMutation };
};
